import React from 'react'
import Button from '@mostrans/web-components/components/base/Button'
import FormGroup from '@mostrans/web-components/components/base/FormGroup'
import Input from '@mostrans/web-components/components/base/Input'
import { Dialog, DialogActions, DialogContent, DialogTitle, Link } from '@mui/material'
import Dropzone from "@mostrans/web-components/components/base/Dropzone";
import Select from '@mostrans/web-components/components/base/Select'
import { errMssgHelper, fileValidation, generateFileName, toastError, toastSuccess } from '../../../../shared/helpers'
import { UpdateRecruitmentResult } from '../../../../GQL/mutations'
import { useApolloClient } from '@apollo/client'
import { uploadResultDocument } from '../../../../shared/firebaseServices'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { errInputAtom, globalLoadingNonScreenAtom } from '../../../../shared/globalStates'
import GlobalLoading from '../../../../shared/GlobalLoading'

function ModalAssignResult(props) {
    const { modalIsOpen, handleModalIsOpen } = props
    const { fetchCandidateResult } = props
    const { idResult } = props
    const { filesUpload, setFilesUpload } = props
    const { urlFile, setUrlFile } = props
    const { resultValue, setResultValue } = props
    const setIsLoading = useSetRecoilState(globalLoadingNonScreenAtom)
    const [errInput, setErrInput] = useRecoilState(errInputAtom)
    const client = useApolloClient()

    let today = new Date();
    let getDateTime = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate() + " " + today.getHours() + ":"
        + today.getMinutes() + ":"
        + today.getSeconds();

    const handleUploadResultDocument = async (file) => {
        if (!fileValidation(file.name)) {
            return toastError("NOK: file format not supported.")
        }
        setFilesUpload(file.name)
        const docName = generateFileName("RESULT-", file.name)
        try {
            setIsLoading(true)
            const url_file = await uploadResultDocument(file, docName)
            setUrlFile(url_file)
        } catch (error) {
            toastError(error)
        } finally {
            setIsLoading(false)
        }
    }

    const handleSubmitResult = async () => {
        const paramUpdate = {
            id: idResult,
            result: resultValue.resultName,
            remarks: resultValue.remarks,
            date_process: getDateTime,
            link_attachment: urlFile ? urlFile : null
        }
        if (idResult === ""
            || resultValue.resultName === ""
            || resultValue.remarks === "") {
            return setErrInput(true)
        }
        try {
            const resultUpdate = await UpdateRecruitmentResult(client, paramUpdate)
            if (resultUpdate.errMsg === "OK") {
                toastSuccess("Result Submitted")
                fetchCandidateResult()
                handleModalIsOpen()
            } else {
                toastError(resultUpdate.errMsg)
            }
        } catch (error) {
            toastError(error)
        }
    }

    return (
        <React.Fragment>
            <Dialog fullWidth open={modalIsOpen} onClose={handleModalIsOpen}>
                <DialogTitle>
                    Assign Result Recruitment Process
                </DialogTitle>
                <DialogContent>
                    <div className="col-md-12 mt-2">
                        <FormGroup
                            label={<p style={{ fontSize: "12px" }}>Result</p>}
                            showChildErrorSign
                            errorMessage={
                                errMssgHelper("Result is required")
                            }
                            isError={errInput && !resultValue.resultName}
                        >
                            <Select
                                onChange={(e) => setResultValue({ ...resultValue, resultName: e.value })}
                                options={[
                                    { value: "PASSED", label: "PASSED" },
                                    { value: "CONSIDER", label: "CONSIDER" },
                                    { value: "FAILED", label: "FAILED" }
                                ]}
                                isClearable
                                placeholder="Select Result" />
                        </FormGroup>
                    </div>
                    <div className="col-md-12 mt-2">
                        <FormGroup
                            label={<p style={{ fontSize: "12px" }}>Remarks</p>}
                            showChildErrorSign
                            errorMessage={errMssgHelper("Remarks is required.")}
                            isError={errInput && !resultValue.remarks}
                        >
                            <Input type="text" placeholder="Entry Remarks"
                                onChange={(e) => setResultValue({ ...resultValue, remarks: e.target.value })}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-md-12 mt-2">
                        <FormGroup
                            label={<p style={{ fontSize: "12px" }}>Attachment</p>}
                        // showChildErrorSign
                        // errorMessage={errMssgHelper("File attachment is required.")}
                        // isError={errInput && !urlFile}
                        >
                            <Dropzone
                                topText={<GlobalLoading />}
                                onChange={(files) => handleUploadResultDocument(files[0])}
                                // accept=".xlsx"
                                middleText={urlFile ?
                                    <Link href={urlFile} underline="hover">{filesUpload}</Link>
                                    : "Drag & Drop or Click to Select File"}
                            />
                        </FormGroup>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button color='error' onClick={handleModalIsOpen}>
                        Close
                    </Button>
                    <Button color='success' onClick={handleSubmitResult}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment >
    )
}

export default ModalAssignResult